import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../reducers/rootReducer';

export const selectProjects = (state: AppState) => state.appReducer.apps;
const idSelector = (_: any, id: string) => id;

export const selectProjectById = createSelector(selectProjects, idSelector, (apps, id) => {
  if (!apps || apps.length <= 0) return null;
  return apps?.find((app) => app.info.applicationId === id);
});
